module.exports = __webpack_public_path__ + "img/meetingRoomtwo.bf66d69d.png";